import React, { Component } from 'react'
import { localize, getLocale } from '../../util/Localizer'

import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'

import RBButton from '../../controls/RBButton'
import DialogStyles from '../../styles/components/dialog'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import { withStyles } from '@material-ui/core/styles'

import NgrxAuth from '../../auth/Auth'

class ContactUs extends Component {
  constructor () {
    super()
    this.handleClose = this.handleClose.bind(this)
    this.handleOpen = this.handleOpen.bind(this)
    this.state = {
      open: false
    }
  }
  handleOpen (e) {
    e.preventDefault()
    this.setState({ open: true })
  }

  handleClose () {
    this.setState({ open: false })
  }
  render () {
    const actions = [
      <RBButton
        key='close'
        variant='outlined'
        label={localize('common.contactus.close')}
        primary={false}
        onClick={this.handleClose}
      />
    ]
    const loc = getLocale()
    const { appContent = {} } = this.props
    const { contentItemText = {} } = appContent
    let { content = '' } = contentItemText[loc] || {}

    if (NgrxAuth.isAuthenticated) {
      // HACK : currently since we show the contact us from the DB, there is no way to figure out what the number is
      // but it is setup as <span>[phone number]<span/> so we just use a regex to replace the content in between the span
      // but if the format changes this will not work ¯\_(ツ)_/¯ - Done by Mark ... some people like my hacks :P
      content = content.replace(/<span>(.*)<\/span>/, `<span>${NgrxAuth.memberHelpLineNumber}</span>`)
      // this is looking for a string like `<p>Monday to Friday 8:30 AM To 7:00 PM (Eastern Standard Time)</p>` but does not grab a specific time
      // at this point in time it should not work on french but have not been able to test a french hour string as its not available
      content = content.replace(/<p>[a-zA-Z]+\s+to\s[a-zA-Z]+\s+\d{1,2}:\d{2}\s*(A|P)M\s+to\s+\d{1,2}:\d{2}\s*(A|P)M(?:(?!<\/p>).)*<\/p>/i, `<p>${NgrxAuth.memberHelpLineHours}</p>`)
    }

    return (
      <div>
        {this.props.type === 'menu'
          ? <ListItem button onClick={this.handleOpen}>
            <ListItemText primary={localize('common.contactus.title')} />
          </ListItem>
          : <a href='' id='contactus' onClick={this.handleOpen}>{localize('common.contactus.title')}</a>}
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          className={this.props.classes.baseDialog}
        >
          <DialogTitle>{localize('common.contactus.title')}</DialogTitle>
          <DialogContent className='contactUs'>
            <div dangerouslySetInnerHTML={{ __html: content }} />
            <DialogActions>{actions}</DialogActions>
          </DialogContent>
        </Dialog>
      </div>
    )
  }
}

const styles = {
  ...DialogStyles
}

export default withStyles(styles)(ContactUs)



// WEBPACK FOOTER //
// ./src/widgets/common/ContactUs.js